import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';

const Profile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    return (
        <div className="bg-white rounded-lg p-4 shadow-sm mb-4">
            <div className="flex justify-between items-center mb-4">
                <h2 className="font-display text-xl font-bold">Profile</h2>
                <button
                    onClick={handleLogout}
                    className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                >
                    Logout
                </button>
            </div>
            <div>
                <p className="text-gray-500">Coming Soon</p>
            </div>
        </div>
    );
};

export default Profile;
